type ProjectLocale = 'ru' | 'uz';
export const STORE_ID = Number(document.body.dataset.storeId);
export const LOCALE = document.documentElement.lang as ProjectLocale;
